import {useContext} from 'react';

import {Navigate} from 'react-router-dom';

import {UserContext} from '../../../contexts/UserContext/UserContext';
import {AppConfig} from '../../../lib/AppConfig';
import {ROLE_APPLICANT, ROLE_COMPANY_ADMIN} from '../../../lib/constants';

// @TODO remove this component. Keeping for now because backend often navigates to old "/profile" route.
const ProfilePage = () => {
  const {currentUser} = useContext(UserContext);

  return (
    <>
      {currentUser && currentUser.role.type === ROLE_APPLICANT && <Navigate to={AppConfig.APPLICANT_PROFILE_PATH} />}

      {currentUser && currentUser.role.type === ROLE_COMPANY_ADMIN && <Navigate to={AppConfig.COMPANY_PROFILE_PATH} />}
    </>
  );
};

export default ProfilePage;
